import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import { AnnotationsDetailsComponent } from './components/annotations-details/annotations-details.component';
import { AnnotationsListComponent } from './components/annotations-list/annotations-list.component';
const routes: Routes = [
  {path: '', component: AnnotationsListComponent ,  pathMatch: 'full'},
  {path: 'details', component: AnnotationsDetailsComponent},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AnnotationsRoutingModule {
}

